import { render, staticRenderFns } from "./Peso.vue?vue&type=template&id=7ca137f0&scoped=true"
import script from "./Peso.vue?vue&type=script&lang=js"
export * from "./Peso.vue?vue&type=script&lang=js"
import style0 from "./Peso.vue?vue&type=style&index=0&id=7ca137f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca137f0",
  null
  
)

export default component.exports